import { render, staticRenderFns } from "./collapsed-menu.vue?vue&type=template&id=49cceee2"
import script from "./collapsed-menu.vue?vue&type=script&lang=js"
export * from "./collapsed-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49cceee2')) {
      api.createRecord('49cceee2', component.options)
    } else {
      api.reload('49cceee2', component.options)
    }
    module.hot.accept("./collapsed-menu.vue?vue&type=template&id=49cceee2", function () {
      api.rerender('49cceee2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/components/side-menu/collapsed-menu.vue"
export default component.exports